import { BaseService } from "services/_baseService";

class PlansAdminService extends BaseService<any> {
  constructor() {
    super(`plans`);
  }
}

export default new PlansAdminService();
